import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map } from 'rxjs';
import { AuthStore } from '../store/auth-store';

export const publicOnlyGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  // Wait until loading is done, then emit canActivate value once.
  return toObservable(authStore.isDoneLoading).pipe(
    filter(isDone => isDone),
    map(() => {
      if (authStore.isAuthenticated()) {
        return router.createUrlTree(['/dashboard']);
      }
      return true;
    })
  );
};
